import { Component, HostListener, OnInit } from '@angular/core';
// Modelos
// Servicios
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import {ConfirmacionesService} from '../../../services/confirmaciones.service';
import { CotizacionesService } from 'app/services/cotizaciones.service';
import { Router } from '@angular/router';
import { ClientesService } from 'app/services/clientes.service';
import { DisponibilidadGeneralHelperService } from '../../../services/helpers/disponibilidad-general-helper.service';
import { AvailabilityCalculatorService } from '../../../services/business-logic/availability-calculator.service';
import { DateUtilsService } from '../../../services/helpers/date-utils.service';
import { DISPONIBILIDAD_CONSTANTS } from './disponibilidad.constants';
@Component({
    templateUrl: './disponibilidad.component.html'
})

export class DisponibilidadComponent implements OnInit {

    private currentUser:any;
    constructor(
        private usuariosPersonalService:UsuariosPersonalService,
        private cotizacionesService: CotizacionesService,
        private confirmacionesService: ConfirmacionesService,
        private servicioClientes: ClientesService,
        private router:Router,
        private disponibilidadGeneralHelper: DisponibilidadGeneralHelperService,
        private availabilityCalculator: AvailabilityCalculatorService,
        private dateUtils: DateUtilsService){
    }
    idCotizacion:string;
    cotizacion:any = {};
    viajesDelTipo:any
    objUnidades:any = {}
    solicitudesDelUsuario:any = []
    solicitudes:any
    solicitudesFiltered:any
    solicitudesDelUsuarioConfirmaciones:any = []
    solicitudesConfirmaciones:any
    solicitudesFilteredConfirmaciones:any
    modulo:string;
    verTodasLasSolicitudes:boolean = false;
    cambiarVerCanceladasYExpiradas:boolean = false;
    cambiarVerConfirmaciones:boolean = false;
    show:boolean = false;
    solicitudToShow:any
    shouldShowPrioVentasButton:boolean = false;
    maxDate = this.dateUtils.toISODateString(new Date());
    showLoader:boolean = false;
    // fecha de busqueda inicilizada en ayer
    fechaBusquedaInicio: any = this.dateUtils.toISODateString(
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * DISPONIBILIDAD_CONSTANTS.DEFAULT_SEARCH_RANGE_DAYS)
    );
    fechaBusquedaFin:any = this.dateUtils.toISODateString(new Date());

    filtroPrioridad:string = "";
    filtroEstatusOperaciones:string = "";
    filtroEstatus:string = "";
    filtroCliente:string = "";
    filtroPrecio:number = 0;
    filtroUsuario:string = "";
    clientes:any = [];
    priceSort:number = 0;
    tipoBusqueda:string = "fechaCreacion";

    kpi_cantidadSolicitudes:any = {
    }

    totalSolicitudesConRespuestaOperaciones:number = 0;
    totalSolicitudesConRespuestaVentas:number = 0;
    promedioRespuestaOperaciones:string = '-';
    promedioRespuestaVentas:string = '-';
    confirmacionesAtipicas:any = { expirada: 0, pendiente: 0, redireccionada: 0, otro: 0, total: 0 };

    // Disponibilidad General properties
    availabilityData:any = {
        dateFrom: new Date(),
        dateTo: new Date(),
        unitTypes: [],
        dates: [],
        table: {},
        loading: false,
        office: 'TC CDMX',
        expanded: true  // Open by default
    };

    // Función de OnInit
    ngOnInit(){
        this.currentUser = this.usuariosPersonalService.auth;
        this.modulo = this.router.url.split('/')[1];

        if(DISPONIBILIDAD_CONSTANTS.PRIVILEGED_USERS.includes(this.currentUser.uid))
            {
                this.shouldShowPrioVentasButton = true;
            }

        // Set default date range for Disponibilidad General: today + 7 days
        const today = new Date();
        const oneWeekFromToday = new Date();
        oneWeekFromToday.setDate(today.getDate() + DISPONIBILIDAD_CONSTANTS.DEFAULT_AVAILABILITY_RANGE_DAYS);

        // Convert to YYYY-MM-DD format for date inputs
        this.availabilityData.dateFrom = this.dateUtils.toISODateString(today);
        this.availabilityData.dateTo = this.dateUtils.toISODateString(oneWeekFromToday);
    }

    limpiarFiltros()
    {
        this.filtroPrioridad = "";
        this.filtroEstatusOperaciones = "";
        this.filtroEstatus = "";
        this.filtroCliente = "";
        //this.filtroPrecio = 0;
        this.priceSort = 0;
        this.filtroUsuario = "";
        this.filtrarSolicitudes()
    }

    changePriceSort()
    {
        if(this.priceSort === 2)
        {
            this.priceSort = 0;
        }
        else{
            this.priceSort++;
        }
        this.filtrarSolicitudes()
    }


    verInfo(solicitud)
    {
        this.show = true
        this.solicitudToShow = solicitud

        this.servicioClientes.obtenerPropiedadCliente(solicitud.info_cotizacion.cliente ,'nombre').valueChanges().take(1).subscribe(nombre=>{
            this.solicitudToShow.nombreCliente = nombre;
        });
        
    }


    getInfoUnidades(cotizacion){
        const unidades = []
        if(cotizacion.combinacion)
        {
            let combinacion = cotizacion.combinacion.combinacion
            let tipoDeUnidad = "";
            let cantidad = 0;
            
            Object.keys(combinacion).forEach(key => {
                    if(combinacion[key]>0){
                        tipoDeUnidad = key;
                        cantidad =combinacion[key];
                        unidades.push(tipoDeUnidad+" x"+cantidad);
                    }
            });
    
            
        }
        return unidades.join(', ');
    }

    getRowBackGroundColorFromPrioVentas(solicitud)
    {
        if(solicitud.prio_ventas === "normal")
        {
            return 'antiquewhite';
        }
    }

    cambiarPrio(solicitud, newPrio)
    {
        this.cotizacionesService.cambiarPrioVentas(solicitud.id_solicitud_disponibilidad,newPrio).take(1).subscribe(res => {
            console.log("res",res)
            alert("Prioridad cambiada correctamente")
            solicitud.prio_ventas = newPrio;
        })
    }

    cambiarVista()
    {
        this.cambiarVerConfirmaciones = !this.cambiarVerConfirmaciones;
        this.filtrarSolicitudes()
    }
    
    cambiarVerCancelatasYPasadas()
    {
        this.cambiarVerCanceladasYExpiradas = !this.cambiarVerCanceladasYExpiradas;
        this.filtrarSolicitudes()
    }
    cambiarVerTodasLasSolicitudes(){
        this.verTodasLasSolicitudes = !this.verTodasLasSolicitudes;
        this.filtrarSolicitudes()
    }

    getViajesPorFechaDeInicioDeServicio()
    {
        console.log('this.cotizacion',this.cotizacion)
        this.confirmacionesService.getViajesPorFechaDeInicioDeServicio(this.cotizacion.serviciosArreglo[0].itinerario.inicioDeServicio, this.cotizacion.serviciosArreglo[0].itinerario.finDeServicio).take(1).subscribe(res2 => {
            let viajes = res2 as Array<any>;

            console.log('this.viajesDelTipo',this.viajesDelTipo)

            viajes.forEach(function(viaje) {
                if(viaje.unidad)
                {
                    viaje.unidad = JSON.parse(viaje.unidad);
                }
                else{
                    viaje.unidad = {
                        clave: "No asignada"
                    }
                }
            })

            this.objUnidades.map(unidad => {
                let viajeFound = viajes.find((v: any) => v.unidad.clave === unidad.clave);
                if(viajeFound)
                {
                    unidad.enRuta = viajeFound.idTrosten
                }
                else{
                    unidad.enRuta = false;
                }
            })
            console.log('objUnidades',this.objUnidades)

            
        })
    }

    getRemainingTime(fecha_aceptacion)
    {
        return this.dateUtils.getRemainingTime(fecha_aceptacion);
    }

    resolicitarSolicitud(solicitud)
    {
        this.cotizacionesService.cambiarEstatusVentas('Caducada', solicitud.id_solicitud_disponibilidad,'Solicitud Caducada').take(1).subscribe((res) => {
            console.log('res',res)
            this.cotizacionesService.crearSolicitudDisponibilidad(solicitud.key_cotizacion,solicitud.info_cotizacion,this.currentUser.uid,solicitud.comentarios_ventas,solicitud.prioridad,solicitud.indicacionesEspeciales).take(1).subscribe((res) => {
                alert("Solicitud de disponibilidad resolicitada correctamente")
                window.location.reload();
            })
        })
    }

    cambiarEstatusVentas(estatus, solicitud)
    {
        var razon = prompt("Porfavor ingresa la razón para la cancelación", "");
        if (razon != null) {
            this.cotizacionesService.cambiarEstatusVentas(estatus, solicitud.id_solicitud_disponibilidad,razon).take(1).subscribe((res) => {
                console.log("res",res)
                alert("Solicitud de disponibilidad actualizada correctamente")
                window.location.reload();
            })
        }
       
    }

    getUnidadesSolicitadas(solicitud)
    {
        let unidadesSolicitadas = []
        let unidades = solicitud.info_confirmacion.unidadesSolicitadas;
        Object.keys(unidades).forEach(key => {
            if(unidades[key]>0)
            {
                let unidad = unidades[key];
                unidadesSolicitadas.push(key+" x"+unidad)
            }
            
        })
        return unidadesSolicitadas.join(', ');
    }

    getHoursSince(fecha_expiracion)
    {
        return this.dateUtils.getHoursSince(fecha_expiracion);
    }

    getHoursBetweenDates(fecha1, fecha2)
    {
        return this.dateUtils.getHoursBetween(fecha1, fecha2);
    }

    private calcBusinessElapsedMinutes(startStr: any, endStr: any): number
    {
        const startMs = new Date(startStr).getTime();
        const endMs = new Date(endStr).getTime();
        return this.dateUtils.getBusinessElapsedMinutes(
            startMs, endMs,
            DISPONIBILIDAD_CONSTANTS.OFF_HOURS.START_HOUR,
            DISPONIBILIDAD_CONSTANTS.OFF_HOURS.END_HOUR
        );
    }

    private classifyResponseTime(minutes: number): string
    {
        const b = DISPONIBILIDAD_CONSTANTS.RESPONSE_TIME_BUCKETS;
        if (minutes < b.UNDER_30)    { return 'under30'; }
        if (minutes < b.MIN_30_TO_60){ return 'min30to60'; }
        if (minutes < b.H1_TO_2)     { return 'h1to2'; }
        if (minutes < b.H2_TO_3)     { return 'h2to3'; }
        return 'over3';
    }

    private formatMinutes(totalMinutes: number): string
    {
        const hours = Math.floor(totalMinutes / 60);
        const mins  = totalMinutes % 60;
        if (hours > 0) {
            return hours + 'h ' + (mins > 0 ? mins + 'm' : '');
        }
        return mins + 'm';
    }

    getTimeSince(fecha_expiracion)
    {
        return this.dateUtils.getTimeSince(fecha_expiracion);
    }

    buscarSolicitudes()
    {
        this.showLoader = true;
        let promises = []
        this.confirmacionesService.getSolicitudesDisponibilidadPorRangoDeFechas(this.fechaBusquedaInicio,this.fechaBusquedaFin,this.tipoBusqueda).take(1).subscribe(res2 => {
            //console.log('res2',res2)
            this.solicitudes = []
            this.solicitudesDelUsuario = []
            this.clientes = []
            this.solicitudesFiltered = []
            this.solicitudes = res2 as Array<any>;
            this.solicitudes.forEach(solicitud => {
                if(solicitud.info_cotizacion)
                {
                    try
                    {
                        solicitud.info_cotizacion = solicitud.info_cotizacion.replace(/[\n\r\t]+/g, " ");
                        solicitud.info_cotizacion = JSON.parse(solicitud.info_cotizacion);
                    }catch(e)
                    {
                    }
                }
                if(solicitud.info_confirmacion)
                {
                    solicitud.info_confirmacion = JSON.parse(solicitud.info_confirmacion);
                }
                else{
                    solicitud.info_confirmacion = {}
                }
                if(solicitud.usuario_solicitante === this.currentUser.uid)
                {
                    this.solicitudesDelUsuario.push(solicitud);
                }

                const cliente = solicitud.info_cotizacion.cliente;
                
                this.servicioClientes.obtenerPropiedadCliente(cliente ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                    let clienteFound = this.clientes.find(c => c.key === cliente);
                    if(!clienteFound)
                    this.clientes.push({nombre:nombre, key:cliente})
                    this.clientes.sort((a,b) => {
                        return a.nombre.localeCompare(b.nombre);
                    })
                });
            })
            
            this.solicitudes.sort((a,b) => {
                return ( new Date(b.fecha_creacion)).getTime() - (new Date(a.fecha_creacion)).getTime();
            })
            this.solicitudesDelUsuario.sort((a,b) => {
                return ( new Date(b.fecha_creacion)).getTime() - (new Date(a.fecha_creacion)).getTime();
            })
            let respuestasOperaciones = {
                under30: 0, min30to60: 0, h1to2: 0, h2to3: 0, over3: 0,
                count: 0, sumMinutes: 0
            };

            let respuestasVentas = {
                under30: 0, min30to60: 0, h1to2: 0, h2to3: 0, over3: 0,
                count: 0, sumMinutes: 0
            };

            let confirmacionesAtipicas = { expirada: 0, pendiente: 0, redireccionada: 0, otro: 0, total: 0 };

            this.solicitudes.forEach(solicitud => {
                if (solicitud.fecha_respuesta) {
                    const minutes = this.calcBusinessElapsedMinutes(solicitud.fecha_creacion, solicitud.fecha_respuesta);
                    const bucket = this.classifyResponseTime(minutes);
                    respuestasOperaciones[bucket]++;
                    respuestasOperaciones.count++;
                    respuestasOperaciones.sumMinutes += minutes;
                }
                if (solicitud.fecha_confirmacion && solicitud.estatus_operaciones === 'Aceptada' && solicitud.fecha_respuesta) {
                    const minutes = this.calcBusinessElapsedMinutes(solicitud.fecha_respuesta, solicitud.fecha_confirmacion);
                    const bucket = this.classifyResponseTime(minutes);
                    respuestasVentas[bucket]++;
                    respuestasVentas.count++;
                    respuestasVentas.sumMinutes += minutes;
                } else if (solicitud.fecha_confirmacion && solicitud.estatus_operaciones !== 'Aceptada') {
                    confirmacionesAtipicas.total++;
                    if (solicitud.estatus_operaciones === 'Expirada')         { confirmacionesAtipicas.expirada++; }
                    else if (solicitud.estatus_operaciones === 'Pendiente')    { confirmacionesAtipicas.pendiente++; }
                    else if (solicitud.estatus_operaciones === 'Redireccionada') { confirmacionesAtipicas.redireccionada++; }
                    else                                                       { confirmacionesAtipicas.otro++; }
                }
            });

            this.confirmacionesAtipicas = confirmacionesAtipicas;

            this.kpi_cantidadSolicitudes = {
                respuestasOperaciones: respuestasOperaciones,
                respuestasVentas: respuestasVentas
            };

            this.promedioRespuestaOperaciones = respuestasOperaciones.count > 0
                ? this.formatMinutes(Math.round(respuestasOperaciones.sumMinutes / respuestasOperaciones.count))
                : '-';
            this.promedioRespuestaVentas = respuestasVentas.count > 0
                ? this.formatMinutes(Math.round(respuestasVentas.sumMinutes / respuestasVentas.count))
                : '-';

            this.solicitudesFiltered = this.solicitudes

            this.totalSolicitudesConRespuestaOperaciones = this.solicitudesFiltered.filter(solicitud => solicitud.fecha_respuesta).length;
            this.totalSolicitudesConRespuestaVentas = this.solicitudesFiltered.filter(solicitud => solicitud.fecha_confirmacion).length;

            this.filtrarSolicitudes()
            this.cambioTimer()
            this.lastUpdated = new Date();
            this.showLoader = false;
        })
    }

    cambioFiltros()
    {
        this.filtrarSolicitudes()
    }

    filtrarSolicitudes()
    {
        let solicitudesAux;
        if(this.filtroUsuario !== "")
        {
            solicitudesAux = JSON.parse(JSON.stringify(this.solicitudesDelUsuario));
        }
        else{
            solicitudesAux = JSON.parse(JSON.stringify(this.solicitudes));
        }

        
        if(this.filtroPrioridad !== "")
        {
            solicitudesAux = solicitudesAux.filter(solicitud => {
                return solicitud.prio_ventas === this.filtroPrioridad;
            })
        }

        if(this.filtroEstatusOperaciones !== "")
        {
            solicitudesAux = solicitudesAux.filter(solicitud => {
                return solicitud.estatus_operaciones === this.filtroEstatusOperaciones;
            })
        }

        if(this.filtroEstatus !== "")
        {
            if(this.filtroEstatus !== "PorCaducar")
            {
                solicitudesAux = solicitudesAux.filter(solicitud => {
                    return solicitud.estatus === this.filtroEstatus;
                })
            }
            else{
                solicitudesAux = solicitudesAux.filter(solicitud => {
                    return solicitud.estatus === "Pendiente" &&
                           solicitud.estatus_operaciones==="Aceptada" &&
                           this.getHoursSince(solicitud.fecha_respuesta) >= DISPONIBILIDAD_CONSTANTS.WARNING_HOURS.EXPIRING_SOON_MIN &&
                           this.getHoursSince(solicitud.fecha_respuesta) < DISPONIBILIDAD_CONSTANTS.WARNING_HOURS.EXPIRING_SOON_MAX;
                })
            }
            
        }

        if(this.filtroCliente !== "")
        {
            solicitudesAux = solicitudesAux.filter(solicitud => {
                return solicitud.info_cotizacion.cliente === this.filtroCliente;
            })
        }

        if(this.filtroPrecio !== 0)
        {
            solicitudesAux = solicitudesAux.filter(solicitud => {
                return solicitud.info_cotizacion.combinacion.total >= this.filtroPrecio;
            })
        }

        console.log('this.priceSort',this.priceSort)
        if(this.priceSort === 1)
        {
            solicitudesAux.sort((a,b) => {
                if(a.info_cotizacion.combinacion && b.info_cotizacion.combinacion)
                return a.info_cotizacion.combinacion.total - b.info_cotizacion.combinacion.total;
                else return 0;
            })
        }
        else if(this.priceSort === 2)
        {
            solicitudesAux.sort((a,b) => {
                if(a.info_cotizacion.combinacion && b.info_cotizacion.combinacion)
                return b.info_cotizacion.combinacion.total - a.info_cotizacion.combinacion.total;
                else return 0;
            })
        }

        this.solicitudesFiltered = solicitudesAux;
        this.totalSolicitudesConRespuestaOperaciones = this.solicitudesFiltered.filter(solicitud => solicitud.fecha_respuesta).length;
        this.totalSolicitudesConRespuestaVentas = this.solicitudesFiltered.filter(solicitud => solicitud.fecha_confirmacion).length;
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        console.log(event);
        let keyPressed = event.key;
        if (keyPressed === "Escape" && this.show) {
            this.show = false;
        }
    }

    timer = DISPONIBILIDAD_CONSTANTS.DEFAULT_TIMER_MS
    timerStr = String(DISPONIBILIDAD_CONSTANTS.DEFAULT_TIMER_MS)
    lastUpdated = null
    timerPromise = null
  cambioTimer() {
    if(this.timerPromise)
    clearInterval(this.timerPromise)
    this.timer = parseInt(this.timerStr)
    this.timerPromise = setInterval(()=>{
        this.buscarSolicitudes()
    }, this.timer)
  }

  descargarReporteCotisPasadasPorDispos()
  {
 
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute(
      "action",
      DISPONIBILIDAD_CONSTANTS.REPORT_URLS.COTIS_PASADAS_POR_DISPOS
    );
    form.setAttribute("target", "name");
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "json";
    input.value = JSON.stringify(this.solicitudes);
    form.appendChild(input);
    const input2 = document.createElement("input");
    input2.type = "hidden";
    input2.name = "date";
    input2.value = this.fechaBusquedaInicio
    const input3 = document.createElement("input");
    input2.type = "hidden";
    input2.name = "dateF";
    input2.value = this.fechaBusquedaFin
    form.appendChild(input);
    form.appendChild(input2);
    form.appendChild(input3);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  descargarReporteDeSolicitudesDeDisponibilidad()
  {
    const fields = {
        fechaInicio: this.fechaBusquedaInicio,
        fechaFin: this.fechaBusquedaFin,
    };

    this.descargarReporte(
      DISPONIBILIDAD_CONSTANTS.REPORT_URLS.SOLICITUDES_DISPONIBILIDAD,
      fields
    );
  }

  descargarReporte(url, fields)
  {
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute(
      "action",
        url
    );
    form.setAttribute("target", "name");

    Object.keys(fields).forEach(key => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  /**
   * Toggle Disponibilidad General panel visibility
   */
  toggleDisponibilidadGeneral() {
    this.availabilityData.expanded = !this.availabilityData.expanded;
  }

  /**
   * Adjusts JavaScript weekday (0=Sunday) to Monday-first (0=Monday)
   */
  private getAdjustedWeekday(weekday: number): number {
    return this.dateUtils.getMondayFirstWeekday(weekday);
  }

  /**
   * Main search method for Disponibilidad General
   * Fetches servicios and solicitudes, builds table data
   */
  buscarDisponibilidadUnidades() {
    this.availabilityData.loading = true;

    // Parse date strings directly to avoid timezone issues
    const fromMs = this.dateUtils.parseDateStringToTimestamp(this.availabilityData.dateFrom, false);
    const toMs = this.dateUtils.parseDateStringToTimestamp(this.availabilityData.dateTo, true);

    const promiseServicios = this.confirmacionesService.getServiciosEnRango(fromMs, toMs);
    const promiseSolicitudes = this.confirmacionesService.getSolicitudesDisponibilidadAceptadasSinConfirmarPorDia(fromMs, toMs);

    Promise.all([promiseServicios, promiseSolicitudes]).then((results: any[]) => {
      const servicios = results[0];
      const solicitudesData = results[1];

      const solicitudes = [];
      if (solicitudesData.data && solicitudesData.data.length > 0) {
        solicitudesData.data.forEach((sol: any) => {
          try {
            if (sol.info_cotizacion) {
              sol.info_cotizacion = JSON.parse(sol.info_cotizacion);
            }
            if (sol.parejas) {
              sol.parejas = JSON.parse(sol.parejas);
            }
            solicitudes.push(sol);
          } catch (e) {
            // Skip invalid JSON
          }
        });
      }

      // Filter by office
      let filteredServicios = servicios;
      let filteredSolicitudes = solicitudes;

      if (this.availabilityData.office) {
        if (this.availabilityData.office === 'QUERETARO') {
          filteredServicios = servicios.filter((servicio: any) => {
            return servicio.oficinaDeOrigen === DISPONIBILIDAD_CONSTANTS.OFFICE_IDS.QUERETARO;
          });
          filteredSolicitudes = solicitudes.filter((solicitud: any) => {
            return solicitud.info_cotizacion.oficinaDeOrigen === DISPONIBILIDAD_CONSTANTS.OFFICE_IDS.QUERETARO;
          });
        } else if (this.availabilityData.office === 'TC CDMX') {
          filteredServicios = servicios.filter((servicio: any) => {
            return DISPONIBILIDAD_CONSTANTS.OFFICE_IDS.TC_CDMX_FILTER(servicio.oficinaDeOrigen);
          });
          filteredSolicitudes = solicitudes.filter((solicitud: any) => {
            return DISPONIBILIDAD_CONSTANTS.OFFICE_IDS.TC_CDMX_FILTER(solicitud.info_cotizacion.oficinaDeOrigen);
          });
        }
      }

      // Build date buckets and categorize
      const buckets = this.disponibilidadGeneralHelper.buildDateBuckets(fromMs, toMs);
      this.disponibilidadGeneralHelper.categorizeServiciosIntoBuckets(buckets, filteredServicios);
      this.disponibilidadGeneralHelper.categorizeSolicitudesIntoBuckets(buckets, filteredSolicitudes);

      // Build dates array
      this.availabilityData.unitTypes = this.disponibilidadGeneralHelper.getAllUnitTypes();
      this.availabilityData.dates = [];
      this.availabilityData.table = {};

      const dayNames = DISPONIBILIDAD_CONSTANTS.DAY_NAMES;

      for (const key in buckets) {
        if (buckets.hasOwnProperty(key)) {
          const dateObj = new Date(buckets[key].timestamp);
          const dayName = dayNames[this.getAdjustedWeekday(dateObj.getDay())];

          this.availabilityData.dates.push({
            key: key,
            display: key,
            dayName: dayName
          });
        }
      }

      // Sort dates
      this.availabilityData.dates.sort((a: any, b: any) => {
        return a.key.localeCompare(b.key);
      });

      // Build table data
      for (let i = 0; i < this.availabilityData.unitTypes.length; i++) {
        const unitType = this.availabilityData.unitTypes[i];
        this.availabilityData.table[unitType] = {};

        for (let j = 0; j < this.availabilityData.dates.length; j++) {
          const dateKey = this.availabilityData.dates[j].key;
          const services = buckets[dateKey].services;
          const solicitudesBucket = buckets[dateKey].solicitudes || [];
          const counts = this.disponibilidadGeneralHelper.countUnitsByType(services, unitType);
          const solicitudesCounts = this.disponibilidadGeneralHelper.countSolicitudesByType(solicitudesBucket, unitType);

          let weekday = buckets[dateKey].timestamp ? new Date(buckets[dateKey].timestamp).getDay() : 0;
          weekday = this.getAdjustedWeekday(weekday);
          const threshold = this.availabilityCalculator.getAvailabilityThreshold(
            this.availabilityData.office,
            unitType,
            weekday
          );

          this.availabilityData.table[unitType][dateKey] = {
            counts: counts,
            threshold: threshold,
            weekday: weekday,
            solicitudesCounts: solicitudesCounts
          };
        }
      }

      this.availabilityData.loading = false;
    }).catch((error: any) => {
      this.availabilityData.loading = false;
      alert('Error al cargar disponibilidad: ' + error.message);
    });
  }

  /**
   * Get cell background color based on threshold comparison
   * Green = OK, Red = threshold reached/exceeded or SIEMPRE
   */
  getCellBackgroundColor(unitType: string, dateKey: string): string {
    const cell = this.availabilityData.table[unitType][dateKey];
    if (!cell) {
      return 'transparent';
    }

    const total = cell.counts.total;
    const threshold = cell.threshold;

    if (total > 0) {
      if (threshold === 'SIEMPRE' || total >= threshold) {
        return '#f8d7da'; // Red (Foundation alert color)
      } else {
        return '#d4edda'; // Green (Foundation success color)
      }
    }

    return 'transparent';
  }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/disponibilidad/disponibilidad.component.ts